"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductFromPresentationEdge = exports.getStableProductEdges = void 0;
const getStableProductEdges = (currentEdges, previousEdges, hasCurrentData) => {
    var _a;
    const hasIncompleteProducts = currentEdges.some(({ node }) => { var _a; return !((_a = node === null || node === void 0 ? void 0 : node.product) === null || _a === void 0 ? void 0 : _a.id); });
    const isEvictionGap = !hasCurrentData && ((_a = previousEdges === null || previousEdges === void 0 ? void 0 : previousEdges.length) !== null && _a !== void 0 ? _a : 0) > 0;
    return hasIncompleteProducts || isEvictionGap
        ? (previousEdges !== null && previousEdges !== void 0 ? previousEdges : [])
        : currentEdges;
};
exports.getStableProductEdges = getStableProductEdges;
const getProductFromPresentationEdge = ({ node }, skipLabelValidation) => {
    var _a, _b, _c, _d, _e;
    const _f = node.product, { presentations } = _f, product = __rest(_f, ["presentations"]);
    const { productTreeNodeId, productTreeNode } = (_b = (_a = presentations === null || presentations === void 0 ? void 0 : presentations.edges[0]) === null || _a === void 0 ? void 0 : _a.node) !== null && _b !== void 0 ? _b : {};
    const strategyAttributeLabels = skipLabelValidation
        ? undefined
        : ((_e = (_d = (_c = productTreeNode === null || productTreeNode === void 0 ? void 0 : productTreeNode.labelValidation) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.map(({ node: labelNode }) => labelNode.label)) !== null && _e !== void 0 ? _e : []);
    return Object.assign(Object.assign({}, product), { productTreeNodeId,
        strategyAttributeLabels });
};
exports.getProductFromPresentationEdge = getProductFromPresentationEdge;
